const useErrors = (
    httpResponseErrors = {},
    yupFormState = {
        errors: {},
        isSubmitted: false,
        isDirty: false,
        isLoading: false,
        isSubmitSuccessful: false,
        isSubmitting: false,
        isValidating: false,
        isValid: false,
        submitCount: 0,
        touchedFields: {},
        dirtyFields: {},
        disabled: false,
        validatingFields: {}
    }
) => {
    let errors = {};
    const { errors: yupErrors } = yupFormState;

    let length = 0;

    if (typeof httpResponseErrors === 'object') {
        Object.keys(httpResponseErrors).forEach((key) => {
            const keyErrors = httpResponseErrors[key];
            const keySplit = key.split('.');

            if (keySplit.length > 1) {
                if (keySplit[1] in errors) {
                    keyErrors.forEach((message) => {
                        if (!Array.isArray(errors[keySplit[1]])) {
                            if (message in errors[keySplit[1]]) {
                                errors[keySplit[1]][message].push(Number(keySplit[0]) + 1);
                            } else {
                                errors = {
                                    ...errors,
                                    [keySplit[1]]: {
                                        ...errors[keySplit[1]],
                                        [message]: [Number(keySplit[0]) + 1]
                                    }
                                };
                                length += 1;
                            }
                        }
                    });
                } else {
                    let partial = {};

                    keyErrors.forEach((message) => {
                        partial = {
                            ...partial,
                            [message]: [Number(keySplit[0]) + 1]
                        };
                        length += 1;
                    });

                    errors = {
                        ...errors,
                        [keySplit[1]]: partial
                    };
                }
            } else {
                const messages = [];

                keyErrors.forEach((message) => {
                    messages.push(message);
                    length += 1;
                });

                errors[key] = messages;
            }
        });
    }

    Object.keys(yupErrors).forEach((key) => {
        const error = yupErrors[key];

        if (Array.isArray(error)) {
            let currentIndex = 0;

            error.forEach((singleError, singleErrorIndex) => {
                for (currentIndex; currentIndex < singleErrorIndex; currentIndex += 1) {
                    if (errors[key] && Array.isArray(errors[key])) {
                        errors = {
                            ...errors,
                            [key]: [...errors[key], undefined]
                        };
                    } else {
                        errors = {
                            ...errors,
                            [key]: [undefined]
                        };
                    }
                }

                let partialErrors = {};

                Object.keys(singleError).forEach((singleErrorKey) => {
                    const partialError = singleError[singleErrorKey];

                    if (partialError?.message) {
                        const errorMessage = partialError.message;

                        if (singleErrorKey in partialErrors) {
                            partialErrors[singleErrorKey].push(errorMessage);
                            length += 1;
                        } else {
                            partialErrors = {
                                ...partialErrors,
                                [singleErrorKey]: [errorMessage]
                            };
                            length += 1;
                        }
                    }
                });

                if (errors[key] && Array.isArray(errors[key])) {
                    errors = {
                        ...errors,
                        [key]: [...errors[key], partialErrors]
                    };
                } else {
                    errors = {
                        ...errors,
                        [key]: [partialErrors]
                    };
                }

                currentIndex += 1;
            });
        } else {
            if (error?.message) {
                const errorMessage = error.message;

                if (errors[key]) {
                    if (Array.isArray(errors[key]) && !errors[key].includes(errorMessage)) {
                        errors[key].push(errorMessage);
                        length += 1;
                    }
                } else {
                    errors[key] = [errorMessage];
                    length += 1;
                }
            }
        }
    });

    return { errors: errors, length };
};

export { useErrors };
